class SPFormRemoveFieldset extends HTMLElement {
	connectedCallback() {
		this.form = this.closest('[data-form]');

		this.button = this.querySelector('button');
		this.button.addEventListener('click', this.removeFieldset.bind(this));
	}

	removeFieldset(e) {
		e.preventDefault();
		const field = this.closest('[data-fieldset-id]');
		if (!field) return true;

		// Add class for animation.
		field.dataset.remove = 'true';

		// Wait for animation frame end before removing the field.
		field.addEventListener('animationend', () => {
			field.remove();

			// Emit input update event on form.
			const event = new Event('input', {
				bubbles: true,
				cancelable: true
			});
			this.form.dispatchEvent(event);
		});
	}
}

export default () => {
	customElements.define('sp-form-remove-fieldset', SPFormRemoveFieldset);
};
